export default __webpack_public_path__ + "static/media/sleeping-svg.9f434a83.svg";